<div class="user-manager">
  <div class="page-header">
    <h2>User Management</h2>
    <p>Search, filter, and manage all registered profiles.</p>
  </div>

  <!-- Filters -->
  <div class="filter-bar">
    <div class="search-box">
      <span class="material-symbols-outlined">search</span>
      <input type="text" placeholder="Search name or email..." [(ngModel)]="searchQuery" (input)="onSearch()">
    </div>
    <select [(ngModel)]="filterGender" (change)="loadUsers()">
      <option value="">All Genders</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
    </select>
    <select [(ngModel)]="filterPlan" (change)="loadUsers()">
      <option value="">All Plans</option>
      <option value="FREE">Free</option>
      <option value="SILVER">Silver</option>
      <option value="GOLD">Gold</option>
      <option value="PLATINUM">Platinum</option>
    </select>
    <select [(ngModel)]="filterSort" (change)="loadUsers()">
      <option value="newest">Newest First</option>
      <option value="oldest">Oldest First</option>
    </select>
  </div>

  <!-- Table -->
  <div class="users-table-wrap">
    <table class="users-table" *ngIf="users.length > 0">
      <thead>
        <tr>
          <th>Profile</th>
          <th>Gender</th>
          <th>Plan</th>
          <th>Status</th>
          <th>Joined</th>
          <th>Last Seen</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td class="td-profile">
            <img *ngIf="getProfilePhoto(user)" [src]="getProfilePhoto(user)" class="profile-thumb" style="object-fit: cover;">
            <div *ngIf="!getProfilePhoto(user)" class="profile-thumb">
              {{ getInitials(user) }}
            </div>
            <div>
              <div class="user-name">{{ getFullName(user) }}</div>
              <div class="user-email">{{ user.basic_info?.email }}</div>
            </div>
          </td>
          <td>
            <span class="gender-badge" [class]="user.basic_info?.gender?.toLowerCase()">
              {{ user.basic_info?.gender || '—' }}
            </span>
          </td>
          <td>
            <span class="plan-pill" [class]="'plan-' + (user.current_plan || 'free').toLowerCase()">
              {{ user.current_plan || 'FREE' }}
            </span>
          </td>
          <td>
            <span class="status-dot" [class]="user.subscription_status?.toLowerCase()"></span>
            {{ user.subscription_status || 'ACTIVE' }}
          </td>
          <td class="td-date">{{ user.profile_ctd_dt | date:'mediumDate' }}</td>
          <td class="td-date">{{ user.last_seen ? (user.last_seen | date:'mediumDate') : '—' }}</td>
          <td>
            <div class="action-btns">
              <button class="btn-action view" (click)="openDetail(user)" title="View Details">
                <span class="material-symbols-outlined">visibility</span>
              </button>
              <button class="btn-action upgrade" (click)="openPlanModal(user)" title="Change Plan">
                <span class="material-symbols-outlined">card_membership</span>
              </button>
              <button class="btn-action suspend" (click)="toggleSuspend(user)"
                [title]="user.subscription_status === 'CANCELLED' ? 'Activate' : 'Suspend'">
                <span class="material-symbols-outlined">
                  {{ user.subscription_status === 'CANCELLED' ? 'check_circle' : 'block' }}
                </span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="empty-state" *ngIf="users.length === 0 && !loading">
      <span class="material-symbols-outlined">search_off</span>
      <p>No users found</p>
    </div>

    <div class="loading-state" *ngIf="loading">
      <span class="material-symbols-outlined spin">autorenew</span> Loading users...
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination" *ngIf="totalPages > 1">
    <button [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
      <span class="material-symbols-outlined">chevron_left</span>
    </button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button [disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">
      <span class="material-symbols-outlined">chevron_right</span>
    </button>
  </div>

  <!-- User Detail Modal -->
  <div class="modal-overlay" *ngIf="detailModalUser" (click)="closeDetailModal()">
    <div class="modal-card detail-card" style="max-width: 780px; max-height: 90vh; overflow-y: auto; padding: 28px;" (click)="$event.stopPropagation()">
      <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 1px solid #eee; padding-bottom: 16px; margin-bottom: 18px; gap: 16px;">
        <div style="display: flex; align-items: center; gap: 16px;">
          <img *ngIf="getProfilePhoto(detailModalUser)" [src]="getProfilePhoto(detailModalUser)" style="width: 68px; height: 68px; border-radius: 50%; object-fit: cover; border: 3px solid #b01e3e; box-shadow: 0 4px 10px rgba(176,30,62,0.15); flex-shrink: 0;">
          <div *ngIf="!getProfilePhoto(detailModalUser)" style="width: 68px; height: 68px; border-radius: 50%; background: linear-gradient(135deg, #B01E3E, #921934); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; box-shadow: 0 4px 10px rgba(176,30,62,0.15); flex-shrink: 0;">
            {{ getInitials(detailModalUser) }}
          </div>
          <div>
            <h3 style="margin: 0 0 4px 0; color: #B01E3E; font-size: 22px; font-weight: 800;">{{ getFullName(detailModalUser) }}</h3>
            <span style="font-size: 13px; color: #666; font-weight: 500;">Profile ID: {{ detailModalUser.profile_id || detailModalUser._id }} | Created by: {{ getVal(detailModalUser.personal_info?.profile_created_by) }}</span>
          </div>
        </div>
        <button (click)="closeDetailModal()" style="background: none; border: none; cursor: pointer; font-size: 28px; color: #777; line-height: 1;">×</button>
      </div>

      <div *ngIf="loadingDetail" style="text-align: center; padding: 40px; color: #666;">
        <span class="material-symbols-outlined spin" style="font-size: 32px; color: #B01E3E;">autorenew</span>
        <p style="margin: 10px 0 0; font-weight: 600;">Loading full profile details...</p>
      </div>

      <div *ngIf="!loadingDetail" class="detail-content" style="display: flex; flex-direction: column; gap: 18px; font-size: 13.5px; text-align: left; color: #333;">
        
        <!-- Top Summary Bar -->
        <div style="display: flex; flex-wrap: wrap; gap: 12px; background: #fdf2f4; padding: 12px 16px; border-radius: 10px; border: 1px solid #f8d7da; align-items: center; justify-content: space-between;">
          <div>
            <strong style="color: #b01e3e;">Plan:</strong> <span style="font-weight: 700; background: #b01e3e; color: #fff; padding: 2px 8px; border-radius: 4px; font-size: 11px; margin-left: 4px;">{{ detailModalUser.current_plan || 'FREE' }}</span>
          </div>
          <div>
            <strong>Status:</strong> <span [style.color]="detailModalUser.subscription_status === 'ACTIVE' ? '#198754' : '#dc3545'" style="font-weight: 700;">{{ detailModalUser.subscription_status || 'ACTIVE' }}</span>
          </div>
          <div>
            <strong>Plan Expiry:</strong> {{ detailModalUser.plan_expiry ? (detailModalUser.plan_expiry | date:'mediumDate') : '—' }}
          </div>
          <div>
            <strong>Registered On:</strong> {{ detailModalUser.profile_ctd_dt ? (detailModalUser.profile_ctd_dt | date:'mediumDate') : '—' }}
          </div>
          <div>
            <strong>Last Seen:</strong> {{ detailModalUser.last_seen ? (detailModalUser.last_seen | date:'short') : '—' }}
          </div>
        </div>

        <!-- Section 1: Basic & Personal Info -->
        <div class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 12px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">Basic & Personal Info</h4>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div><strong>Email:</strong> {{ getVal(detailModalUser.basic_info?.email) }}</div>
            <div><strong>Mobile:</strong> +91 {{ getVal(detailModalUser.basic_info?.mobile || detailModalUser.basic_info?.phone) }}</div>
            <div><strong>Gender:</strong> {{ getVal(detailModalUser.basic_info?.gender) }}</div>
            <div><strong>Date of Birth:</strong> {{ detailModalUser.basic_info?.date_of_birth ? (detailModalUser.basic_info.date_of_birth | date:'mediumDate') + ' (' + (detailModalUser.basic_info?.age || '—') + ' yrs)' : getVal(detailModalUser.basic_info?.age ? detailModalUser.basic_info.age + ' yrs' : null) }}</div>
            <div><strong>Mother Tongue:</strong> {{ getLookup(detailModalUser.basic_info?.mother_lang_id, 'language_name', 'language_nme') }}</div>
            <div><strong>Marital Status:</strong> {{ getVal(detailModalUser.personal_info?.marital_status) }}</div>
            <div><strong>Height / Weight:</strong> {{ detailModalUser.personal_info?.height ? detailModalUser.personal_info.height + ' cm' : '—' }} / {{ detailModalUser.personal_info?.weight ? detailModalUser.personal_info.weight + ' kg' : '—' }}</div>
            <div><strong>Body Type:</strong> {{ getVal(detailModalUser.personal_info?.body_type) }}</div>
            <div><strong>Physical Status:</strong> {{ getVal(detailModalUser.personal_info?.physical_status) }}</div>
            <div><strong>Eating Habits:</strong> {{ getVal(detailModalUser.personal_info?.food) }}</div>
            <div><strong>Smoking / Drinking:</strong> {{ getVal(detailModalUser.personal_info?.smoking) }} / {{ getVal(detailModalUser.personal_info?.drinking) }}</div>
            <div><strong>Blood Group:</strong> {{ getVal(detailModalUser.personal_info?.blood_group) }}</div>
            <div><strong>Citizenship:</strong> {{ getLookup(detailModalUser.personal_info?.citizenship_id, 'citizenship_name', 'citizenship_nme') }}</div>
            <div><strong>Languages Known:</strong> {{ getLanguagesSpoken(detailModalUser) }}</div>
          </div>
        </div>

        <!-- Section 2: About Me / Bio -->
        <div *ngIf="detailModalUser.personal_info?.about_me" class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 8px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">About Me & Bio</h4>
          <p style="margin: 0; line-height: 1.5; color: #444; white-space: pre-line;">{{ detailModalUser.personal_info.about_me }}</p>
        </div>

        <!-- Section 3: Professional & Career Details -->
        <div class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 12px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">Professional Details</h4>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div><strong>Education Type:</strong> {{ getLookup(detailModalUser.professional_info?.educationtype_id, 'educationtype_name', 'educationtype_nme') }}</div>
            <div><strong>Highest Degree:</strong> {{ getLookup(detailModalUser.professional_info?.education_id, 'education_name', 'education_nme') }}</div>
            <div *ngIf="detailModalUser.professional_info?.education_detail || detailModalUser.professional_info?.eduinstitution_id">
              <strong>College / Institution:</strong> {{ detailModalUser.professional_info?.education_detail || getLookup(detailModalUser.professional_info?.eduinstitution_id, 'eduinstitution_name', 'eduinstitution_nme') }}
            </div>
            <div *ngIf="detailModalUser.professional_info?.higher_education_detail || detailModalUser.professional_info?.eduuniversity_id">
              <strong>University / Higher Edu:</strong> {{ detailModalUser.professional_info?.higher_education_detail || getLookup(detailModalUser.professional_info?.eduuniversity_id, 'eduuniversity_name', 'eduuniversity_nme') }}
            </div>
            <div><strong>Employment Type:</strong> {{ getLookup(detailModalUser.professional_info?.employmentype_id, 'employmentype_name', 'employmentype_nme') }}</div>
            <div><strong>Occupation Category:</strong> {{ getLookup(detailModalUser.professional_info?.occupation_id, 'occupation_name', 'occupation_nme') }}</div>
            <div><strong>Designation / Job Title:</strong> {{ getVal(detailModalUser.professional_info?.occupation_detail) }}</div>
            <div><strong>Annual Income:</strong> {{ detailModalUser.professional_info?.annual_salary ? '₹' + (detailModalUser.professional_info.annual_salary | number) : getLookup(detailModalUser.professional_info?.income_id, 'income_name', 'income_nme') }}</div>
            <div *ngIf="detailModalUser.professional_info?.additional_income_source" style="color: #b01e3e;">
              <strong>Additional Income Source:</strong> {{ detailModalUser.professional_info.additional_income_source }}
            </div>
            <div *ngIf="detailModalUser.professional_info?.additional_annual_income" style="color: #b01e3e;">
              <strong>Additional Annual Income:</strong> ₹{{ detailModalUser.professional_info.additional_annual_income | number }}
            </div>
            <div><strong>Work City:</strong> {{ getLookup(detailModalUser.professional_info?.work_city_id, 'city_name') }}</div>
            <div><strong>Work State / Country:</strong> {{ getLookup(detailModalUser.professional_info?.work_state_id, 'state_name') }}{{ detailModalUser.professional_info?.work_country_id ? ' (' + getLookup(detailModalUser.professional_info.work_country_id, 'country_name') + ')' : '' }}</div>
          </div>
        </div>

        <!-- Section 4: Religion, Caste & Astrological Info -->
        <div class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 12px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">Religion & Astrological Details</h4>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div><strong>Religion:</strong> {{ getLookup(detailModalUser.religion_info?.religion_id, 'religion_name', 'religion_nme') }}</div>
            <div><strong>Caste:</strong> {{ getLookup(detailModalUser.religion_info?.caste_id, 'caste_name', 'caste_nme') }}</div>
            <div><strong>Sub-Caste:</strong> {{ getLookup(detailModalUser.religion_info?.sub_caste_id, 'subcaste_name', 'subcaste_nme') }}</div>
            <div><strong>Gothram:</strong> {{ getLookup(detailModalUser.religion_info?.gothrm_id, 'gothram_name', 'gothram_nme') }}</div>
            <div><strong>Chevvai Dosham:</strong> {{ getVal(detailModalUser.religion_info?.dosham) }}</div>
            <div><strong>Want Same Community:</strong> {{ detailModalUser.religion_info?.want_same_community === true ? 'Yes' : (detailModalUser.religion_info?.want_same_community === false ? 'No' : '—') }}</div>
            <div><strong>Star (Nakshatram):</strong> {{ getLookup(detailModalUser.religion_info?.natchr_id || detailModalUser.horoscope_info?.natchr_id, 'nakshatra_name', 'nakshatra_nme') }}</div>
            <div><strong>Rasi (Moon Sign):</strong> {{ getLookup(detailModalUser.religion_info?.rasi_id || detailModalUser.horoscope_info?.rasi_id, 'rasi_name', 'rasi_nme') }}</div>
            <div><strong>Time of Birth:</strong> {{ getVal(detailModalUser.horoscope_info?.time_of_birth) }}</div>
            <div><strong>Place of Birth:</strong> {{ getLookup(detailModalUser.horoscope_info?.city_id, 'city_name') }}{{ detailModalUser.horoscope_info?.state_id ? ', ' + getLookup(detailModalUser.horoscope_info.state_id, 'state_name') : '' }}</div>
          </div>
        </div>

        <!-- Section 5: Residing Location & Address -->
        <div class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 12px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">Residing Location & Address</h4>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div *ngIf="detailModalUser.residing_location?.address1 || detailModalUser.residing_location?.address2" style="grid-column: span 2;">
              <strong>Address:</strong> {{ getAddress(detailModalUser) }}
            </div>
            <div><strong>City:</strong> {{ detailModalUser.residing_location?.city || getLookup(detailModalUser.residing_location?.city_id, 'city_name') }}</div>
            <div><strong>Taluk:</strong> {{ getLookup(detailModalUser.residing_location?.taluk_id, 'taluk_name') }}</div>
            <div><strong>District:</strong> {{ getLookup(detailModalUser.residing_location?.dist_id, 'district_name') }}</div>
            <div><strong>State:</strong> {{ detailModalUser.residing_location?.state || getLookup(detailModalUser.residing_location?.state_id, 'state_name') }}</div>
            <div><strong>Country:</strong> {{ getLookup(detailModalUser.residing_location?.country_id, 'country_name') }}</div>
            <div><strong>Zipcode / Pincode:</strong> {{ getVal(detailModalUser.residing_location?.zipcode) }}</div>
          </div>
        </div>

        <!-- Section 6: Family Details -->
        <div class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 12px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">Family Details</h4>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div><strong>Family Status:</strong> {{ getVal(detailModalUser.family_info?.family_status) }}</div>
            <div><strong>Family Type / Values:</strong> {{ getVal(detailModalUser.family_info?.family_type) }}{{ detailModalUser.family_info?.family_values ? ' / ' + detailModalUser.family_info.family_values : '' }}</div>
            <div><strong>Father's Name:</strong> {{ getVal(detailModalUser.family_info?.father_name) }}</div>
            <div><strong>Mother's Name:</strong> {{ getVal(detailModalUser.family_info?.mother_name) }}</div>
            <div><strong>Brothers:</strong> {{ getVal(detailModalUser.family_info?.no_of_brothers) }}</div>
            <div><strong>Sisters:</strong> {{ getVal(detailModalUser.family_info?.no_of_sisters) }}</div>
            <div><strong>Ancestral Origin:</strong> {{ getVal(detailModalUser.family_info?.ancestral_origin) }}</div>
            <div *ngIf="detailModalUser.family_info?.about_family" style="grid-column: span 2;">
              <strong>About Family:</strong> {{ detailModalUser.family_info.about_family }}
            </div>
          </div>
        </div>

        <!-- Section 7: Verification & Document Status -->
        <div class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 12px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">Verification & Document Status</h4>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div>
              <strong>Mobile Verified:</strong>
              <span [style.color]="detailModalUser.verify?.mobile_verify_status ? '#198754' : '#666'" style="font-weight: 600; margin-left: 4px;">{{ detailModalUser.verify?.mobile_verify_status ? 'Verified ✓' : 'Pending / No' }}</span>
            </div>
            <div>
              <strong>Photo Verified:</strong>
              <span [style.color]="detailModalUser.verify?.photo_verify_status ? '#198754' : '#666'" style="font-weight: 600; margin-left: 4px;">{{ detailModalUser.verify?.photo_verify_status ? 'Verified ✓' : 'Pending / No' }}</span>
            </div>
            <div>
              <strong>ID Proof:</strong>
              <span [style.color]="detailModalUser.verify?.id_proof_verify_status ? '#198754' : '#666'" style="font-weight: 600; margin-left: 4px;">{{ detailModalUser.verify?.id_proof_verify_status ? 'Verified ✓' : 'Pending / No' }}{{ detailModalUser.verify?.id_proof_doc ? ' (' + detailModalUser.verify.id_proof_doc + ')' : '' }}</span>
            </div>
            <div>
              <strong>Education Proof:</strong>
              <span [style.color]="detailModalUser.verify?.edu_proof_verify_status ? '#198754' : '#666'" style="font-weight: 600; margin-left: 4px;">{{ detailModalUser.verify?.edu_proof_verify_status ? 'Verified ✓' : 'Pending / No' }}</span>
            </div>
            <div>
              <strong>Income Proof:</strong>
              <span [style.color]="detailModalUser.verify?.income_proof_verify_status ? '#198754' : '#666'" style="font-weight: 600; margin-left: 4px;">{{ detailModalUser.verify?.income_proof_verify_status ? 'Verified ✓' : 'Pending / No' }}</span>
            </div>
          </div>
        </div>

        <!-- Section 8: Partner Preferences -->
        <div *ngIf="detailModalUser.partner_preferences" class="section-block" style="background: #fdfafb; padding: 16px 20px; border-radius: 10px; border-left: 4px solid #B01E3E; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">
          <h4 style="margin: 0 0 12px 0; font-size: 13px; font-weight: 700; color: #b01e3e; letter-spacing: 0.6px; text-transform: uppercase;">Partner Preferences</h4>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div><strong>Preferred Age:</strong> {{ detailModalUser.partner_preferences.personal_preference?.age_from || '18' }} to {{ detailModalUser.partner_preferences.personal_preference?.age_to || '50' }} yrs</div>
            <div><strong>Preferred Height:</strong> {{ detailModalUser.partner_preferences.personal_preference?.height_from || '140' }} to {{ detailModalUser.partner_preferences.personal_preference?.height_to || '210' }} cm</div>
            <div><strong>Marital Status:</strong> {{ getVal(detailModalUser.partner_preferences.personal_preference?.marital_status) }}</div>
            <div><strong>Preferred Religion:</strong> {{ getLookup(detailModalUser.partner_preferences.religious_preference?.religion_id, 'religion_name', 'religion_nme') }}</div>
            <div><strong>Preferred Caste:</strong> {{ getLookup(detailModalUser.partner_preferences.religious_preference?.caste_id, 'caste_name', 'caste_nme') }}</div>
            <div><strong>Preferred Education:</strong> {{ getLookupList(detailModalUser.partner_preferences.education_preference?.education_id, 'education_name', 'education_nme') }}</div>
            <div><strong>Preferred Occupation:</strong> {{ getLookupList(detailModalUser.partner_preferences.profession_preference?.occupation_id, 'occupation_name', 'occupation_nme') }}</div>
            <div><strong>Preferred Income:</strong> {{ getLookup(detailModalUser.partner_preferences.profession_preference?.income_id, 'income_name', 'income_nme') }}</div>
            <div><strong>Preferred City:</strong> {{ getLookup(detailModalUser.partner_preferences.location_preference?.city_id, 'city_name') }}</div>
            <div><strong>Preferred State:</strong> {{ getLookup(detailModalUser.partner_preferences.location_preference?.state_id, 'state_name') }}</div>
          </div>
        </div>

      </div>

      <div class="modal-actions" style="margin-top: 24px; display: flex; justify-content: flex-end;">
        <button class="btn-cancel" style="padding: 10px 24px; border-radius: 8px; font-weight: 700; cursor: pointer; background: #64748b; color: #fff; border: none;" (click)="closeDetailModal()">Close Details</button>
      </div>
    </div>
  </div>

  <!-- Change Plan Modal -->
  <div class="modal-overlay" *ngIf="planModalUser" (click)="closePlanModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <h3>Change Plan — {{ getFullName(planModalUser) }}</h3>
      <div class="modal-form">
        <div class="form-row">
          <label>New Plan</label>
          <select [(ngModel)]="newPlan">
            <option value="FREE">Free</option>
            <option value="SILVER">Silver</option>
            <option value="GOLD">Gold</option>
            <option value="PLATINUM">Platinum</option>
          </select>
        </div>
        <div class="form-row">
          <label>Expiry (days from today)</label>
          <input type="number" [(ngModel)]="expiryDays" min="1" max="365">
        </div>
        <div class="form-row">
          <label>Reason (internal)</label>
          <input type="text" [(ngModel)]="planChangeReason" placeholder="e.g. Refund adjustment, Support issue">
        </div>
      </div>
      <div class="modal-actions">
        <button class="btn-save" (click)="savePlanChange()" [disabled]="saving">
          {{ saving ? 'Saving...' : 'Update Plan' }}
        </button>
        <button class="btn-cancel" (click)="closePlanModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>
